import { ref } from '@vue/composition-api'
import store from '@/store'

export default function useWorkplaceLock(refetchData) {
  const loading = ref(false)
  const workplaceLockModal = ref(null)

  const workplaceEnableForRequest = ref({
    workplace_id: null,
    workplace_name: null,
    request_enabled_at: '',
    service_type_can_released: '',
    person_type: null,
    advance_deadline_day: null,
  })

  const requestTypeOptions = [
    { label: 'PJ', value: 'PJ' },
    { label: 'PF', value: 'PF' },
  ]

  const serviceTypeCanReleasedOptions = [
    { label: 'Plantão', value: 'physician_duty' },
    { label: 'Serviços', value: 'service_record' },
    { label: 'Todos', value: 'all' },
  ]

  const days = Array.from({ length: 15 }, (_, i) => i + 1)
  const advanceDeadlineDayOptions = ref(days.map(day => ({ label: `${day}`, value: day })))

  function show(workplace) {
    workplaceEnableForRequest.value.workplace_id = workplace.id
    workplaceEnableForRequest.value.workplace_name = workplace.name
    workplaceEnableForRequest.value.request_enabled_at = workplace.request_enabled_at
    const type = requestTypeOptions.find(t => t.value === workplace.person_type)
    workplaceEnableForRequest.value.person_type = type
    const option = serviceTypeCanReleasedOptions.find(t => t.value === workplace.service_type_can_released)
    workplaceEnableForRequest.value.service_type_can_released = option
    const optionDay = advanceDeadlineDayOptions.value.find(t => t.value === workplace.advance_deadline_day)
    workplaceEnableForRequest.value.advance_deadline_day = optionDay.value
    workplaceLockModal.value.show()
  }

  function lockEnableForRequest() {
    loading.value = true
    const payload = {
      ...workplaceEnableForRequest.value,
      person_type: workplaceEnableForRequest.value.person_type.value,
      service_type_can_released: workplaceEnableForRequest.value.service_type_can_released.value,
    }
    store.dispatch('app-institution/enableForRequest', payload)
      .then(() => {
        refetchData()
        loading.value = false
        workplaceLockModal.value.hide()
      }).catch(() => {
        loading.value = false
      })
  }

  return {
    loading,
    workplaceLockModal,
    workplaceEnableForRequest,
    requestTypeOptions,
    serviceTypeCanReleasedOptions,
    advanceDeadlineDayOptions,
    show,
    lockEnableForRequest,
  }
}
